import moment from 'moment-timezone';
import Constants from '../constants/constants';
var regex = Constants.Regex;
/**
 * * checks if a formc is valid for the given user type (dispatcher or field user)
 * @param _formc
 * @param userType
 * @returns {*}
 */
function checkFormValidity(_formc, userType) {
	var _isDirty = false;//assume false unless we find a change
	var errors = [];
	var warnings = [];
	var dateRegex = new RegExp(regex.dateRegex);

	//Check number of subs for modify
	if (_formc.status === Constants.RestrictionStatuses.ISSUED) {
		if (_formc.subdivision === "MULTI" && _formc.subdivisions.length < 2) {
			errors.push({
				field: 'subdivisions',
				message: 'Subdivisions: MULTI subdivision restrictions must have at least two subdivisions',
				type: 'error'
			})
		}

		if (_formc.subdivision !== "MULTI" && _formc.subdivisions.length > 1) {
			errors.push({
				field: 'subdivisions',
				message: "Subdivisions: Restriction must be modified with a single subdivision",
				type: 'error'
			})
		}
	}

	if (!_formc.estimatedRemovalDate || _formc.estimatedRemovalDate.length === 0) {
		errors.push({
			field: 'estimatedRemovalDate',
			message: 'Estimated Removal: Please fill out this field',
			type: 'error'
		})
	} else if (!dateRegex.test(_formc.estimatedRemovalDate)) {
		_isDirty = true;
		errors.push({ field: 'estimatedRemovalDate', message: 'From Date: must be in format MMddYY', type: 'error' });
	}

	if (!_formc.authorizedBy || _formc.authorizedBy.length === 0) {
		errors.push({
			field: 'authorizedBy', message: 'Authorized By: Please fill out this field', type: '' +
				'.error'
		})
	}

	if (_formc.workStartMp.length === 0 && _formc.workStartMpSuffix.length === 0 && _formc.workEndMp.length === 0 && _formc.workEndMpSuffix.length === 0
		&& _formc.subdivisions.length < 2 && _formc.subdivisions[0] !== 'ALL'
	) {
		if (!_formc.fromLocation || _formc.fromLocation.length === 0) {
			errors.push({
				field: 'fromLocation', message: 'From Location: Either From Location or MP is mandatory', type: '' +
					'.error'
			})
		}

		if (!_formc.toLocation || _formc.toLocation.length === 0) {
			errors.push({
				field: 'toLocation', message: 'To Location: Either To Location or MP is mandatory', type: '' +
					'.error'
			})
		}
	}

	//Estimates Removal validation
	let now = moment().tz(Constants.Timezones[_formc.timezone]);
	let estimatedRemoval = moment.tz(_formc.estimatedRemovalDate, 'MMDDYY', Constants.Timezones[_formc.timezone]);

	//verify that estivatedRemoval is a valid date
	if (estimatedRemoval.isValid()) {

		estimatedRemoval.add(23, 'hours').add(59, 'minutes').add(59, 'seconds'); //Set the estimatedRemoval to the end of the day so that it will not be in the past

		if (estimatedRemoval.isBefore(now)) {
			errors.push({
				field: 'expectedExpireDate',
				message: "Estimated Removal Date can't be in the past",
				type: 'error'
			})
		}
	}
	else {
		errors.push({
			field: 'expectedExpireDate',
			message: "Estimated Removal Date must be a valid date",
			type: 'error'
		})
	}

	if (estimatedRemoval.isBefore(now)) {
		errors.push({
			field: 'expectedExpireDate',
			message: "Estimated Removal Date can't be in the past",
			type: 'error'
		})
	}

	//This is to filter out only spaces
	let onlySpacesComment = _formc.comments.map(function (comment) {
		return comment['comment']
	})

	if (_formc.comments.length === 0 || _formc.comments[0].comment === "" || onlySpacesComment.join("").trim().length === 0) {
		errors.push({
			field: 'formCText', message: 'Text: Please fill out this field', type: '' +
				'.error'
		})
	}
	return { isValid: errors.length === 0, errors: errors, isDirty: _isDirty, warnings: warnings }

}
export const formcValidation = { checkFormValidity };